export default () => ({
  container: { display: 'flex' },
  cardContentRoot: { padding: '2em 0 0' },
  card: {
    marginTop: 0,
    marginBottom: 30,
    flex: 1,
    position: 'relative',
    overflow: 'unset',
    maxWidth: '100%',
  },
  actions: {
    display: 'flex',
    flexDirection: 'row-reverse',
  },
  divider: { margin: '.5em 0' },
  statusIcon: {
    color: 'white',
    margin: '1em 0',
  },
  statusIconContainer: {
    display: 'inline-flex',
    flexDirection: 'column',
    margin: '0 1.5em 0 0',
  },
  updateButtonContainer: { position: 'relative' },
  updateProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  selectInput: { padding: '8px 24px 6px 8px' },
  commentFormContainer: { marginTop: 16 },
});
